import { notifyListingPendingApproval } from './api';
import * as log from './log';
import { LISTING_STATE_PENDING_APPROVAL } from './types';

export const createListingSubmissionId = () => {
  if (typeof globalThis !== 'undefined' && globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

/** Notify moderators only after Sharetribe returns a pending-approval listing. */
export const notifyModeratorIfPendingApproval = (listingResponse, submissionId) => {
  const listing = listingResponse?.data?.data || listingResponse?.data;
  const listingId = listing?.id?.uuid;
  if (
    !listingId ||
    !submissionId ||
    listing?.attributes?.state !== LISTING_STATE_PENDING_APPROVAL
  ) {
    return Promise.resolve(false);
  }

  return notifyListingPendingApproval(listingId, submissionId)
    .then(() => true)
    .catch(error => {
      log.error(error, 'moderation-notification-request-failed', { listingId });
      return false;
    });
};